
import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; //

const CustomPhoneInputd = ({ value, onChange ,onKeyDown  }) => {
    return (
        <div className="w-full">
            <PhoneInput
             country={"us"}
             onKeyDown={onKeyDown} 
                value={value}
                onChange={(phone, country) => {
                    const fullNumber = phone.startsWith("+") ? phone : `+${phone}`;
                    onChange(fullNumber, country);
                }}
                enableSearch={true}
                countryCodeEditable={false}
                containerClass="w-full"
                inputClass="!w-full !h-11 !p-4 !pl-12 !border !rounded"
                buttonClass="!bg-gray-200 !border-r !rounded-l"
            />
        </div>
    );
};


export default CustomPhoneInputd;
